import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, ArrowLeft } from 'lucide-react';
import ApprovalQueue from '@/components/ApprovalQueue';

const PendingList = ({ onBack, onDecisionComplete, currentUser }) => {
  return (
    <div>
      <Card className="mb-6 border-yellow-200 bg-gradient-to-r from-yellow-50 to-amber-50">
        <CardHeader>
          <div className="flex items-center gap-3">
            <Button variant="outline" size="sm" onClick={onBack}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
            <CardTitle className="flex items-center gap-2">
              <Clock className="h-6 w-6 text-yellow-600" />
              Ausstehende Unternehmen
            </CardTitle>
          </div>
        </CardHeader>
      </Card>

      <ApprovalQueue 
        onDecisionComplete={onDecisionComplete}
        currentUser={currentUser}
      />
    </div>
  );
};

export default PendingList;
